import { createReducer, on } from '@ngrx/store';
import { reportRecurringDeleteSuccess, reportRecurringLoadSuccess } from './report-recurring.action';
import { reportRecurringEntityAdapter } from './report-recurring.state';

export const reportRecurringReducer = createReducer(
  reportRecurringEntityAdapter.getInitialState(),
  on(reportRecurringLoadSuccess, (state, { reports }) => reportRecurringEntityAdapter.setAll(reports, state)),
  on(reportRecurringDeleteSuccess, (state, { id }) => reportRecurringEntityAdapter.removeOne(id, state))
);
